import { render } from "./Undergrad.vue?vue&type=template&id=25618ac8&scoped=true"
import script from "./Undergrad.vue?vue&type=script&lang=js"
export * from "./Undergrad.vue?vue&type=script&lang=js"

import "./Undergrad.vue?vue&type=style&index=0&id=25618ac8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tmeadows\\WebstormProjects\\tuitioncalculator\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25618ac8"]])

export default __exports__